import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import {
  Edit,
  Eye,
  RotateCcw,
  Trash2,
  UserX,
  CreditCard,
} from "feather-icons-react/build/IconComponents";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import ViewRegistration from "./View";
import EditRegistration from "./Edit";
import Swal from "sweetalert2";
import AddRegistration from "./Add";
import ResignRegistration from "./Resign";
import Axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  ROLL_CALL_EMPLOYEES_LIST,
  ROLL_CALL_API_BASE_URL,
} from "../RollCallConfig/RollCallConfig";
import { Button, Input, Select, Spin } from "antd";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { isShiftPlanEnabled } from "../../../../feature-module/utils/commonUtils";

const WageRegistrationsList = () => {
  const [viewObj, setViewObj] = useState([]);
  const [editObj, setEditObj] = useState([]);
  const [resignObj, setResignObj] = useState([]);
  const [loading, setLoading] = useState(true);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  const [showEdit, setShowEdit] = useState(false);
  const [showResign, setShowResign] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [editingKey, setEditingKey] = useState(null);
  const [editedRow, setEditedRow] = useState({});
  const [wageSubmitLoading, setWageSubmitLoading] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const fetchEmployees = async () => {
    setLoading(true);
    const EMP_SESSION_KEY = `employees_${superIdData}`;

    try {
      const response = await Axios.get(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      );

      if (response.data.status) {
        setEmployees(response.data.ResultData);
        sessionStorage.setItem(
          EMP_SESSION_KEY,
          JSON.stringify(response.data.ResultData),
        );
      } else {
        console.error(response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchEmployees();
    }
  }, [tokenData, superIdData]);

  const handleDeleteConfirmation = (regid) => {
    if (tokenData) {
      Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(
              `${ROLL_CALL_API_BASE_URL}portal/emp/deleteEmployee`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tokenData}`,
                },
                body: JSON.stringify({ regid: regid }),
              },
            );

            const responseData = await response.json();

            if (responseData.status) {
              Swal.fire(
                "Deleted!",
                "Your item has been deleted.",
                "success",
              ).then(() => {
                // window.location.reload();
                fetchEmployees();
              });
            } else {
              Swal.fire("Error", "Failed to delete .", "error");
            }
          } catch (error) {
            console.error("Error deleting holiday:", error);
            Swal.fire("Error", "Failed to delete ", "error");
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelled", "Your item is safe :)", "info");
        }
      });
    }
  };

  const handleEdit = (record) => {
    setEditingKey(record.RegId);
    setEditedRow({
      RegId: record.RegId,
      RegFinId: record.RegFinId || 0,
      WageType: record.WageType,
      WageAmount: record.WageAmount,
    });
  };

  const handleWageChange = (field, value) => {
    setEditedRow((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleWageSave = async () => {
    if (
      editedRow.WageType === undefined ||
      editedRow.WageType === null ||
      editedRow.WageAmount === undefined ||
      editedRow.WageAmount === null ||
      editedRow.WageAmount === ""
    ) {
      Swal.fire({
        icon: "warning",
        title: "Required Fields",
        text: "Please enter Wage Type and Wage Amount",
      });
      return;
    }

    const payload = {
      ...editedRow,
    };

    try {
      setWageSubmitLoading(true);

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}/portal/emp/upsertwage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data.status) {
        const result = await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Wage updated successfully",
        });

        if (result.isConfirmed) {
          fetchEmployees();
        }

        setEditingKey(null);
        setEditedRow({});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Something went wrong",
        });
      }
    } catch (error) {
      console.error("API Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while saving",
      });
    } finally {
      setWageSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    setEditingKey(null);
    setEditedRow({});
  };
  const columns = [
    {
      title: "Emp ID",
      dataIndex: "Badge",
      sorter: (a, b) => Number(a?.Badge || 0) - Number(b?.Badge || 0),
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
      render: (text) => {
        return (
          <span
            title={text}
            // onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            {text?.length > 22 ? `${text.substring(0, 22)}...` : text}
          </span>
        );
      },
    },
    {
      title: "Bio Id",
      dataIndex: "CardId",
      sorter: (a, b) => a.CardId?.length - b.CardId?.length,
      render: (text) => {
        return (
          <span title={text}>
            {text?.length > 5 ? `${text.substring(0, 5)}...` : text}
          </span>
        );
      },
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      sorter: (a, b) => a.Mobile?.length - b.Mobile?.length,
      render: (text) => text || "N/A",
    },
    {
      title: "Email",
      dataIndex: "EmailId",
      sorter: (a, b) => a.EmailId?.length - b.EmailId?.length,
      render: (text) => text || "N/A",
      key: "email",
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation?.length - b.Designation?.length,
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    {
      title: "Dept",
      dataIndex: "DepartmentName",
      sorter: (a, b) => a.DepartmentName?.length - b.DepartmentName?.length,
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    ...(isShiftPlanEnabled()
      ? [
          {
            title: "Shift",
            dataIndex: "ShiftName",
            sorter: (a, b) =>
              (a.ShiftName?.length || 0) - (b.ShiftName?.length || 0),
            render: (text) => (text && text.trim() ? text : "-"),
          },
        ]
      : []),
    {
      title: "Wages",
      render: (_, record) => {
        const isEditing = editingKey === record.RegId;

        const isEmpty =
          !record?.WageType &&
          record?.WageType !== 0 &&
          (record?.WageAmount === undefined ||
            record?.WageAmount === null ||
            record?.WageAmount === "");

        return isEditing ? (
          <div className="d-flex  gap-2">
            <Select
              value={editedRow.WageType}
              onChange={(val) => handleWageChange("WageType", val)}
              options={[
                { label: "Monthly", value: 1 },
                { label: "Daily", value: 2 },
              ]}
              placeholder="Wage Type"
              style={{ width: 100 }}
            />

            <Input
              value={editedRow.WageAmount}
              onChange={(e) => handleWageChange("WageAmount", e.target.value)}
              placeholder="Wage amount"
              style={{ width: 100 }}
              type="number"
            />
          </div>
        ) : isEmpty ? (
          <div className="text-center">-</div>
        ) : (
          <>
            <div className="text-center">
              {record.WageType === 1 ? (
                <span className="badge bg-secondary badge-sm">Monthly</span>
              ) : (
                <span className="badge bg-success badge-sm">Daily</span>
              )}
              <div>{record.WageAmount ?? "-"}</div>
            </div>
          </>
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => {
        const isEditing = editingKey === record.RegId;

        return !isEditing ? (
          <>
            <Link
              className="action-set"
              to="#"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="fa fa-ellipsis-v" aria-hidden="true" />
            </Link>

            <ul className="dropdown-menu">
              <li>
                <Link
                  to="#"
                  className="dropdown-item"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightViewReg"
                  aria-controls="offcanvasRightViewReg"
                  onClick={() => setViewObj(record)}
                >
                  <Eye className="info-img text-primary" />
                  View
                </Link>
              </li>
              {perm?.Write && (
                <>
                  <li>
                    <Link
                      to=""
                      className="dropdown-item"
                      onClick={() => {
                        handelShowEdit(record);
                      }}
                    >
                      <Edit className="info-img text-info" />
                      Edit
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                      className="dropdown-item"
                      onClick={() => handelShowResign(record)}
                    >
                      <UserX className="info-img text-warning" />
                      Resign
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                      className="dropdown-item"
                      onClick={() => handleEdit(record)}
                    >
                      <CreditCard className="info-img text-warning" />
                      Update Wage
                    </Link>
                  </li>
                </>
              )}
              {perm?.Delete && (
                <>
                  <li>
                    <Link
                      className="dropdown-item mb-0"
                      onClick={() => handleDeleteConfirmation(record.RegId)}
                    >
                      <Trash2 className="info-img text-danger" />
                      Delete
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </>
        ) : (
          <>
            <Button
              type="primary"
              icon={<CheckOutlined />}
              size="small"
              onClick={() => handleWageSave()}
            />

            <Button
              danger
              style={{ marginLeft: 8 }}
              icon={<CloseOutlined />}
              size="small"
              onClick={handleCancel}
            />
          </>
        );
      },
    },
  ];

  const finalColumns = editingKey
    ? columns.filter((col) => col.key !== "email")
    : columns;

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (employees && employees?.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = employees?.map((item, index) => ({
      "S.No": index + 1,
      "Emp ID": item.Badge || "N/A",
      Name: item.UserName || "N/A",
      Biometric: item.CardId || "N/A",
      Mobile: item.Mobile || "N/A",
      Email: item.EmailId || "N/A",
      Designation: item.Designation || "N/A",
      Department: item.DepartmentName || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee Data");
    XLSX.writeFile(wb, "Employee_Data.xlsx");
  };

  const generatePDF = () => {
    if (employees && employees?.length === 0) {
      return;
    }

    const doc = new jsPDF("l", "mm", "a4");
    doc.text("Employee Data Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Emp ID",
      "Name",
      "Biometric",
      "Mobile",
      "EmailId",
      "Designation",
      "Department",
    ];
    const tableRows = employees?.map((item, index) => [
      index + 1,
      item.Badge || "N/A",
      item.UserName || "N/A",
      item.CardId || "N/A",
      item.Mobile || "N/A",
      item.EmailId || "N/A",
      item.Designation || "N/A",
      item.DepartmentName || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Employee_Data.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const handelShowEdit = (record) => {
    setShowEdit(true);
    setEditObj(record);
  };

  const handelShowResign = (record) => {
    setShowResign(true);
    setResignObj(record);
  };

  const updateEmployeeInState = () => {
    fetchEmployees();
  };

  return (
    <div>
      {wageSubmitLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Registrations
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your registrations</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}

              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  onClick={() => setShowAdd(true)}
                  title="New Register"
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set">
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="col-6 mb-2">
                      <label className="form-label"></label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive brand-table">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      rowKey="RegId"
                      columns={finalColumns}
                      dataSource={employees}
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
        <CommonFooter />
      </div>
      <>
        <ViewRegistration viewObj={viewObj} />
        <EditRegistration
          isOpen={showEdit}
          editObj={editObj}
          onUpdateSuccess={updateEmployeeInState}
          onClose={() => setShowEdit(false)}
        />

        <ResignRegistration
          isOpen={showResign}
          resignObj={resignObj}
          fetchEmployees={fetchEmployees}
          onClose={() => setShowResign(false)}
        />
        <AddRegistration
          isOpen={showAdd}
          fetchEmployees={fetchEmployees}
          onClose={() => setShowAdd(false)}
        />
      </>
    </div>
  );
};

export default WageRegistrationsList;
